// extracted by mini-css-extract-plugin
module.exports = {"buttonsContainer":"OnGoingPaymentBox_buttonsContainer__3C2vB","resendInfoText":"OnGoingPaymentBox_resendInfoText__KD7VS"};